import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import appUrl from '../../appUrl';
import { Button, Spinner, Card, CardBody, Row, Col, ListGroup, ListGroupItem, Badge } from "react-bootstrap";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaGoogle, FaApple, FaUser, FaCodeBranch, FaCheckCircle, FaMobileAlt } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { FaArrowLeft } from 'react-icons/fa6';
import { RxCrossCircled } from "react-icons/rx";
import "./Profile.css";
import { IoBusiness } from "react-icons/io5";

function UserProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [dataLoading, setDataLoading] = useState(false);
  const [profile, setProfile] = useState(null);

  // const role = queryParams.get('role');
  const id = queryParams.get('id');
  const AppUrl = appUrl();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setDataLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${AppUrl}/getprofile?id=${id}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const data = await response.json();
        setProfile(data.profile);
      } catch (error) {
        console.error(error);
      } finally {
        setDataLoading(false);
      }
    };
    fetchProfile();
  }, [AppUrl, id]);

  return (
    <>
      {dataLoading || !profile ? (
        <div className="loading-spinner">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <div className="container">
          <div className="flex items-center pb-2 justify-between">
            <div className='back-button' onClick={() => navigate(-1)}>
              <FaArrowLeft />
            </div>
          </div>
          <Card className="shadow-sm p-3 mt-2 mb-4 bg-white rounded">
            <CardBody>
              <Row>
                <Col md={4} className="text-center">
                  <img
                    src={profile.profile_photo || "/images/avatar2.png"}
                    alt="Profile"
                    className="rounded-circle img-fluid mb-3"
                    style={{ width: "150px", height: "150px", backgroundColor: "#e1e1e1" }}
                  />
                  <h4 className="text-capitalize">{profile.username}</h4>
                  <Badge bg={profile.status === "active" ? "success" : "secondary"}>{profile.status}</Badge>
                  <p className="text-muted text-capitalize">{profile.role}</p>
                </Col>
                <Col md={8}>
                  <ListGroup>
                    <ListGroupItem className='flex align-items-center gap-1'><FaEnvelope /> {profile.email}</ListGroupItem>
                    {profile.mobile_number && <ListGroupItem className='flex align-items-center gap-1'><FaPhoneAlt /> {profile.mobile_number}</ListGroupItem>}
                    {profile.whats_app && <ListGroupItem className='flex align-items-center gap-1'><RiWhatsappFill style={{ color: "green" }} /> {profile.whats_app}</ListGroupItem>}
                    {profile.country && <ListGroupItem className="flex align-items-center gap-1 text-capitalize"><FaMapMarkerAlt /> {profile.country}</ListGroupItem>}
                  </ListGroup>
                  <div className="mt-3 d-flex align-items-center">
                    <strong className="me-2">Source:</strong>
                    {profile?.userGoogleInfo?.google_email && <FaGoogle className="text-danger me-2" size={20} />}
                    {profile?.userAppleInfo?.apple_email && <FaApple className="text-dark me-2" size={20} />}
                    {!profile?.userGoogleInfo?.google_email && !profile?.userAppleInfo?.apple_email && <FaEnvelope className="text-primary" size={20} />}
                  </div>
                  <ListGroup className="mt-3">
                    {profile.recommended_by && 
                    <ListGroupItem className='flex align-items-center gap-1'>
                      <FaUser />
                      <p>{'Recommended By: '}</p>
                      <p className='font-bold'>
                        {profile.recommended_by}
                      </p>
                    </ListGroupItem>}
                    {profile.agent_code && <ListGroupItem><FaCodeBranch /> Agent Code: {profile.agent_code}</ListGroupItem>}
                    {profile.businessVerified !== undefined && (
                      <ListGroupItem>
                        {profile.businessVerified ?
                          <div className='flex align-items-center gap-1'>
                            <IoBusiness/>
                            <p>{`Business: `}</p>
                            <FaCheckCircle className="text-success"/> 
                            <span className='font-bold'>
                              Verified
                            </span>
                          </div> : 
                          <div className='flex align-items-center gap-1'>
                            <RxCrossCircled className="text-danger"/> 
                            <span>
                              Not Verified
                            </span>
                          </div>
                        }
                      </ListGroupItem>
                    )}
                    {profile.deviceType && 
                    <ListGroupItem className='flex align-items-center gap-1'>
                      <FaMobileAlt /> 
                      <p>{`Device Type: `}</p>
                      <p className='font-bold'>{profile.deviceType}</p>
                    </ListGroupItem>}
                  </ListGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {profile?.role === 'provider' && <div className='flex align-items-center justify-content-end' onClick={() => navigate(`/home/view/business?user=${id}`)}>
            <Button  size='sm' style={{ width: '10rem' }} className='view-details-button-lg px-3 py-2'>
                View Business
            </Button>
          </div>}
        </div>
      )}
    </>
  );
}

export default UserProfile;